import { cacheDom } from "../utils/QuerySelectors.js"

const state = {
  sortOpened: false,
}
const dom = {}
const qs = {
  facetsContainer: 'data-facets-container',
  productsGrid: 'data-products-grid',
  sortContainer: 'data-plp-sort',
  sortBtn: 'data-plp-sort-btn',
}
const qsAll = {
  filterContainers: 'data-plp-filter',
  filterBtns: 'data-plp-filter-btn',
  facets: 'data-facet',
  facetRemoves: 'data-facet-remove',
  clearFacets: 'data-clear',
  sortOptions: 'data-pdp-sort-option',
}

const initFilterFacets = (openedFilterIndexes=[]) => {
  dom.sortContainer.addEventListener('click', (e) => {
    e.stopPropagation()
    dom.filterContainers.forEach(f => f.removeAttribute('open'))
  })
  dom.filterContainers.forEach((filterContainer) => {
    filterContainer.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })

  dom.filterBtns.forEach((filterBtn) => {
    filterBtn.addEventListener('click', (e) => {
      e.stopPropagation()

      dom.filterContainers.forEach((f) => {
        if(f.querySelector(`[${qsAll.filterBtns}]`) != filterBtn) f.removeAttribute('open')
      })
      dom.sortContainer.removeAttribute('open')
    })
  })
  
  dom.facets.forEach((facet) => {
    facet.addEventListener('input', () => {
      renderFilterResults()
    })
  })
  
  dom.clearFacets.forEach((clearBtn) => {
    clearBtn.addEventListener('click', (e) => {
      const removeUrl = e.target.dataset.url
      fetchResults(removeUrl)
    })
  })
  dom.facetRemoves.forEach((facetRemove) => {
    facetRemove.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      
      const removeUrl = `${facetRemove.href}&section_id=${dom.facetsContainer.dataset.sectionId}`
      fetchResults(removeUrl)
    })
  })
  if(openedFilterIndexes.length > 0) openedFilterIndexes.forEach(idx => dom.facetsContainer.querySelector(`details[data-index="${idx}"]`).setAttribute('open', ''))

  if(state.sortOpened) dom.sortContainer.setAttribute('open', true)

  dom.sortOptions.forEach((sortOption) => {
    sortOption.addEventListener('click', (e) => {
      dom.sortOptions.forEach((option) => {
        option.classList.remove('pdp-sort--selected')
      })
      e.target.classList.add('pdp-sort--selected')
      renderFilterResults()
    })
  })
}

const fetchResults = (url) => {
  fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const openedFilterIndexes = []
      dom.facetsContainer.querySelectorAll('details[open]').forEach((detail) => {
        openedFilterIndexes.push(parseInt(detail.dataset.index))
      })
      state.sortOpened = dom.sortContainer.hasAttribute('open')
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      dom.productsGrid.innerHTML = html.querySelector(`[${qs.productsGrid}]`).innerHTML

      cacheDom(dom, qs, qsAll)

      initFilterFacets(openedFilterIndexes)
      
      if(location.pathname != dom.productsGrid.dataset.productsGrid) history.pushState({}, "", dom.productsGrid.dataset.productsGrid)
    })
}

const renderFilterResults = () => {
  const selectedFacets = dom.facets.filter((facet) => facet.checked).map((facet) => encodeURI(`${facet.name}=${facet.value}`)).join('&')
  const filterUrl = `${dom.productsGrid.dataset.productsGrid}?section_id=${dom.facetsContainer.dataset.sectionId}&${selectedFacets}&sort_by=${document.querySelector('.pdp-sort--selected') && document.querySelector('.pdp-sort--selected').dataset.value}`
  fetchResults(filterUrl)
}

export const setupCollection = () => {
  cacheDom(dom, qs, qsAll)
  
  if(dom.sortBtn) {
    document.body.addEventListener('click', () => {
      document.querySelector(`[${qs.sortContainer}]`).removeAttribute('open')
      document.querySelectorAll(`[${qsAll.filterContainers}]`).forEach((filterContainer) => {
        filterContainer.removeAttribute('open')
      })
    })
    initFilterFacets()
  }
}